import {
  Card,
  Collapse,
  ControlGroup,
  EditableText,
  Elevation,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import Symptom from "./Symptom";
import { inject, observer } from "mobx-react";

import cogoToast from "cogo-toast";
import { apiCallPost } from "../../fns/util";
import SuggColl from "../SuggColl";

class Subjective extends React.Component {
  state = {
    searching: false,
    collapse: true,
    notesText: null,
    notesTouched: false,
    searchResults: [],
  };
  renderNotes = () => {
    return (
      <div
        style={{ textAlign: "left", marginTop: "10px", marginBottom: "10px" }}
      >
        <EditableText
          multiline
          placeholder="Write free-form notes here, such as referral notes or complex past history, such as details of trauma. "
          value={
            this.state.notesTouched
              ? this.state.notesText
              : this.props.subjectiveNotes[0].text
          }
          onChange={(event) =>
            this.setState({ notesText: event, notesTouched: true })
          }
          onConfirm={() =>
            this.props.update(
              "subjectiveNotes",
              this.props.subjectiveNotes[0]._id,
              "text",
              this.state.notesTouched
                ? this.state.notesText
                : this.props.subjectiveNotes[0].text
            )
          }
        />
      </div>
    );
  };

  renderSymptoms = () => {
    if (!this.props.symptoms || !this.props.symptoms.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No symptoms added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.props.symptoms.map((each) => {
      return (
        <Symptom
          data={each}
          update={(symptomId, key, value) =>
            this.props.update("symptoms", symptomId, key, value)
          }
          remove={(symptomId) => this.props.remove(symptomId)}
        />
      );
    });
  };

  renderShort = () => {
    if (!this.props.symptoms || !this.props.symptoms.length) {
      return (
        <Tag minimal large>
          No symptoms added.
        </Tag>
      );
    }
    let syms = this.props.symptoms.map((each) => each.symptom);
    let txt = syms.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/clinical/${this.props.authStore.prefix}/unisearch`,
        { prefix: "sym", query: string }
      );
      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.setState({ collapse: !this.state.collapse })}
        >
          Symptoms
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <AsyncSelWrap
            placeholder="Symptoms..."
            searching={this.state.searching}
            items={this.state.searchResults}
            selectedItem={null}
            update={(item) => this.search(item)}
            onChange={(item) => {
              let dd = item.data;
              dd["_id_sr"] = item._id;
              dd["type"] = "new";
              dd["checked"] = false;
              this.props.add("symptoms", dd);
            }}
          />
        )}{" "}
      </ControlGroup>
    );
  };
  render() {
    return (
      <Card
        style={{ padding: "0px", background: "none" }}
        elevation={Elevation.FOUR}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            justifyContent: "left",
            padding: "10px",
          }}
        >
          {this.renderHeading()}
          <Collapse isOpen={this.state.collapse}>
            <SuggColl
              ana_prefix=""
              prefix="sym"
              visitId={this.props.visitId}
              addObjectInside={this.props.addObjectInside}
            />
            {this.renderNotes()}

            {this.renderSymptoms()}
          </Collapse>
        </div>
      </Card>
    );
  }
}

export default inject(
  "bookingStore",
  "authStore",
  "billingStore",
  "patientStore",
  "listStore"
)(observer(Subjective));
